"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const slate_react_1 = require("slate-react");
const BlockMenu_1 = require("./BlockMenu");
const TOOLBAR_HEIGHT = 32;
class BlockState {
    constructor(mutxt, scrollArea) {
        this.mutxt = mutxt;
        this.scrollArea = scrollArea;
        this.dismissed = ui_1.rsync.val(false);
        this.start = () => {
            const mutxt = this.mutxt;
            const unsubscribeCursor = mutxt.cursor.subscribe(() => {
                if (this.dismissed.value)
                    this.dismissed.next(false);
            });
            return () => {
                unsubscribeCursor();
            };
        };
        this.menu = new BlockMenu_1.BlockMenu(mutxt);
    }
    /**
     * Format of the block currently containing the caret, or `undefined` when
     * there's no caret, when there's a range selection, or when the block isn't
     * one we recognize.
     *
     * @todo Rename to `type`?
     */
    currentBlockFormat() {
        const mutxt = this.mutxt;
        const api = mutxt.api;
        const cursor = mutxt.cursor.value;
        const selection = mutxt.selection.value;
        if (!cursor || selection)
            return;
        const blockEntry = api.blockAbove();
        if (!blockEntry)
            return;
        const [element, path] = blockEntry;
        if (element.type === 'embed')
            return;
        if (element.type === 'hr')
            return;
        if (element.type === 'toc')
            return;
        if (element.type === 'math')
            return;
        if (element.type === 'li') {
            const match = api.listAbove(void 0, path);
            if (match)
                return match[0].type;
            return 'p';
        }
        return element.type;
    }
    point() {
        const { mutxt } = this;
        const cursor = mutxt.cursor.value;
        const selection = mutxt.selection.value;
        if (!cursor || selection)
            return;
        try {
            const box = mutxt.editableBox?.value;
            if (!box || !box[2])
                return;
            const focusRect = mutxt.api.focusRect();
            if (!focusRect)
                return;
            const editableEl = slate_react_1.ReactEditor.toDOMNode(mutxt.editor, mutxt.editor);
            const isRtl = getComputedStyle(editableEl).direction === 'rtl';
            const [x, , width] = box;
            return {
                x: isRtl ? x + width - 12 : x + 12,
                y: focusRect.top + focusRect.height / 2,
                dx: isRtl ? 1 : -1,
                dy: 0,
            };
        }
        catch {
            return;
        }
    }
    isInViewport(point) {
        if (!this.scrollArea?.viewportEl)
            return true;
        if (typeof window === 'undefined' || typeof document === 'undefined')
            return true;
        try {
            const viewportRect = this.scrollArea.viewportEl.getBoundingClientRect();
            const halfHeight = TOOLBAR_HEIGHT / 2;
            const top = point.y - halfHeight;
            const bottom = point.y + halfHeight;
            const topOverflow = Math.max(viewportRect.top - top, 0);
            const bottomOverflow = Math.max(bottom - viewportRect.bottom, 0);
            return topOverflow <= 0 && bottomOverflow <= 0;
        }
        catch {
            return false;
        }
    }
}
exports.BlockState = BlockState;
